import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Icon, IconButton } from 'rsuite';

const { Cell } = Table;

const ActionCell = ({
  rowData,
  dataKey,
  handleSelect,
  handleDelete,
  ...props
}) => (
  <Cell {...props} className="link-group">
    {handleSelect && (
      <Button
        style={{ padding: 0, marginTop: -10 }}
        appearance="link"
        onClick={() => {
          handleSelect(rowData[dataKey]);
        }}
      >
        <Icon icon="check-circle" /> Load
      </Button>
    )}
    {handleDelete && (
      <IconButton
        style={{ marginTop: -10 }}
        appearance="link"
        color="red"
        icon={<Icon icon="trash" />}
        onClick={() => handleDelete(rowData)}
      />
    )}
  </Cell>
);

ActionCell.propTypes = {
  rowData: PropTypes.shape({}),
  dataKey: PropTypes.string.isRequired,
  handleSelect: PropTypes.func,
  handleDelete: PropTypes.func
};

ActionCell.defaultProps = {
  rowData: null,
  handleSelect: null,
  handleDelete: null
};

export default ActionCell;
